export type Lang = 'en' | 'es'

export const translations = {
  en: {
    header: {
      tagline: 'A slice of heaven',
      navCheesecake: 'The Cheesecake',
      navOccasions: 'Occasions',
      navEnquiries: 'Enquiries',
      navReserve: 'Reserve',
    },
    hero: {
      eyebrow: 'an invitation',
      sideLeft: 'Signature Basque Cheesecake',
      sideRight: 'Magnolia · Texas · MMXXVI',
      title1: 'One Bite',
      title2: 'Closer',
      title3: 'to Heaven',
      plate: 'Plate Nº 001',
      plateLabel: 'Signature',
      quote:
        '"A deeply caramelized crown. A custard-soft center. A finish that lingers, beautifully."',
      ctaReserve: 'Reserve your first slice',
      ctaFollow: 'Follow @tartahtx',
    },
    marquee: [
      'Caramelized',
      'Custard-Soft',
      'Small-Batch',
      'Hand-Crafted',
      'Magnolia · Texas',
      'Edition Nº 01',
      'Limited Release',
      'Reserved by Invitation',
    ],
    product: {
      eyebrow: 'The Cheesecake',
      title1: 'The Signature',
      title2: 'Basque Cheesecake.',
      intro:
        'A deeply caramelized top. A smooth, creamy center. A finish that lingers. Made simple, elegant, and unforgettable.',
      features: [
        {
          eyebrow: 'Flavor',
          title: 'Caramelized Top',
          copy: 'A deeply burnished crown — bittersweet, complex, unmistakably Basque.',
        },
        {
          eyebrow: 'Texture',
          title: 'Creamy Center',
          copy: 'Velvet-soft and custard-like. The kind of texture you remember for days.',
        },
        {
          eyebrow: 'Presentation',
          title: 'Gift-Ready',
          copy: 'Plated, packaged, and presented with the care of something worth giving.',
        },
      ],
    },
    sensory: {
      eyebrow: 'The Vessel',
      title1: 'Made to be',
      title2: 'Given.',
      copy: 'Each cheesecake arrives in a hand-finished round box, embossed with the TARTA mark and lined with care. A vessel meant to be opened slowly — the unboxing is part of the gift.',
      specs: [
        { l: 'Material', v: 'Embossed paperboard' },
        { l: 'Finish', v: 'Cocoa & cream foil' },
        { l: 'Form', v: 'Hand-finished round' },
        { l: 'Detail', v: 'A slice of heaven' },
      ],
      detailNo: 'Detail Nº 002',
      detailLabel: 'The Box',
    },
    waitlist: {
      invitation: '— by invitation —',
      title1: 'The First',
      title2: 'Bite List',
      copy: 'Our debut release is intentionally small. Members receive a private notice before doors open to the public — and first access when pre-orders begin.',
      benefits: [
        'Private launch notice',
        'First access to pre-orders',
        'Limited first edition',
      ],
      labelName: 'Name',
      labelEmail: 'Email',
      labelPhone: 'Phone',
      placeholderName: 'Full name',
      placeholderEmail: 'you@example.com',
      placeholderPhone: '(optional)',
      optional: 'Optional',
      required: 'Required',
      invalidEmail: 'Invalid email',
      submit: 'Request an invitation',
      footnote: 'No spam — only sweet, deliberate updates.',
      confirmed: '— Confirmed —',
      welcome: 'Welcome,',
      thanks:
        "Your place is reserved on the First Bite List. We'll be in touch when something special is ready.",
    },
    perfectFor: {
      eyebrow: 'Occasions',
      title1: 'For the Moments',
      title2: 'People Remember.',
      moments: [
        {
          title: 'Dinner Parties',
          copy: 'The dessert that ends the evening — and starts the conversation.',
        },
        {
          title: 'Birthdays',
          copy: "A quietly stunning centerpiece for the year's sweetest milestone.",
        },
        {
          title: 'Anniversaries',
          copy: 'Soft, rich, and slow — a love language served in slices.',
        },
        {
          title: 'Host Gifts',
          copy: "Arrive with something they'll talk about long after you leave.",
        },
        {
          title: 'Holiday Tables',
          copy: 'Tradition, refined. A new ritual worth keeping.',
        },
        {
          title: 'Private Events',
          copy: 'A small-batch indulgence for moments that feel curated.',
        },
      ],
    },
    localLaunch: {
      eyebrow: 'Local Launch',
      title1: 'Coming Soon to',
      title2: 'Magnolia, Texas.',
      copy: 'TARTA is preparing for its first release. Follow along — and reserve your place on the First Bite List for early access.',
      points: [
        { label: 'Origin', value: 'Magnolia, Texas' },
        { label: 'Production', value: 'Small-batch' },
        { label: 'Release', value: 'Limited first edition' },
        { label: 'Availability', value: 'Pre-orders soon' },
      ],
    },
    instagram: {
      eyebrow: '@tartahtx',
      title1: 'Follow the',
      title2: 'First Chapter.',
      cta: 'Follow @tartahtx',
      posts: ['The first bake', 'The signature box', 'A slice of heaven'],
    },
    faq: {
      eyebrow: 'Enquiries',
      title1: 'Questions,',
      title2: 'Answered.',
      items: [
        {
          q: 'When will TARTA launch?',
          a: 'Soon. Join the First Bite List to be notified before public release.',
        },
        {
          q: 'Where is TARTA located?',
          a: 'TARTA is based in Magnolia, Texas.',
        },
        {
          q: 'Will pre-orders be available?',
          a: 'Yes. Pre-order details are shared with the waitlist first.',
        },
        {
          q: 'Do you offer custom orders?',
          a: 'Custom and event orders may become available after launch.',
        },
        {
          q: 'How do I stay updated?',
          a: 'Join the waitlist and follow @tartahtx on Instagram.',
        },
      ],
    },
    finalCTA: {
      edition: 'edition nº 01',
      title1: 'Something',
      title2: 'Special',
      title3: 'Is Baking',
      copy1: 'The first release will be intentionally small.',
      copy2: 'Reserve your place before doors open.',
      cta: 'Reserve your first slice',
    },
    footer: {
      tagline: 'A slice of heaven',
      quote: 'One bite closer to heaven.',
      origin: 'Origin',
      originValue: 'Magnolia, Texas',
      originSub: 'Coming Soon',
      follow: 'Follow',
      copyright: 'TARTA',
      crafted: 'Crafted in Magnolia, Texas',
    },
  },

  es: {
    header: {
      tagline: 'Un pedacito de cielo',
      navCheesecake: 'El Pastel',
      navOccasions: 'Ocasiones',
      navEnquiries: 'Consultas',
      navReserve: 'Reservar',
    },
    hero: {
      eyebrow: 'una invitación',
      sideLeft: 'Cheesecake Vasco de Autor',
      sideRight: 'Magnolia · Texas · MMXXVI',
      title1: 'Un Bocado',
      title2: 'Más Cerca',
      title3: 'del Cielo',
      plate: 'Plato Nº 001',
      plateLabel: 'De Autor',
      quote:
        '"Una corona profundamente caramelizada. Un centro suave como natilla. Un final que perdura, bellamente."',
      ctaReserve: 'Reserva tu primera rebanada',
      ctaFollow: 'Síguenos @tartahtx',
    },
    marquee: [
      'Caramelizado',
      'Cremoso',
      'En Lotes Pequeños',
      'Hecho a Mano',
      'Magnolia · Texas',
      'Edición Nº 01',
      'Edición Limitada',
      'Reservado por Invitación',
    ],
    product: {
      eyebrow: 'El Pastel',
      title1: 'El Auténtico',
      title2: 'Cheesecake Vasco.',
      intro:
        'Una corona profundamente caramelizada. Un centro suave y cremoso. Un final que perdura. Hecho simple, elegante e inolvidable.',
      features: [
        {
          eyebrow: 'Sabor',
          title: 'Corona Caramelizada',
          copy: 'Una corona profundamente tostada — agridulce, compleja, inconfundiblemente vasca.',
        },
        {
          eyebrow: 'Textura',
          title: 'Centro Cremoso',
          copy: 'Suave como terciopelo, como natilla. La clase de textura que se recuerda por días.',
        },
        {
          eyebrow: 'Presentación',
          title: 'Listo para Regalar',
          copy: 'Servido, empacado y presentado con el cuidado de algo digno de regalarse.',
        },
      ],
    },
    sensory: {
      eyebrow: 'El Empaque',
      title1: 'Hecho para',
      title2: 'Regalar.',
      copy: 'Cada cheesecake llega en una caja redonda hecha a mano, con el sello TARTA en relieve y forrada con esmero. Un empaque pensado para abrirse despacio — desempacarlo es parte del regalo.',
      specs: [
        { l: 'Material', v: 'Cartón en relieve' },
        { l: 'Acabado', v: 'Cacao y crema' },
        { l: 'Forma', v: 'Redonda hecha a mano' },
        { l: 'Detalle', v: 'Un pedacito de cielo' },
      ],
      detailNo: 'Detalle Nº 002',
      detailLabel: 'La Caja',
    },
    waitlist: {
      invitation: '— por invitación —',
      title1: 'La Lista del',
      title2: 'Primer Bocado',
      copy: 'Nuestro lanzamiento debut es intencionalmente pequeño. Las personas en la lista reciben aviso privado antes de la apertura al público — y acceso prioritario cuando comiencen las pre-órdenes.',
      benefits: [
        'Aviso privado de lanzamiento',
        'Acceso prioritario a pre-órdenes',
        'Primera edición limitada',
      ],
      labelName: 'Nombre',
      labelEmail: 'Correo',
      labelPhone: 'Teléfono',
      placeholderName: 'Nombre completo',
      placeholderEmail: 'tu@ejemplo.com',
      placeholderPhone: '(opcional)',
      optional: 'Opcional',
      required: 'Obligatorio',
      invalidEmail: 'Correo inválido',
      submit: 'Solicitar invitación',
      footnote: 'Sin spam — solo actualizaciones dulces y cuidadas.',
      confirmed: '— Confirmado —',
      welcome: 'Bienvenido,',
      thanks:
        'Tu lugar está reservado en la Lista del Primer Bocado. Te contactaremos cuando algo especial esté listo.',
    },
    perfectFor: {
      eyebrow: 'Ocasiones',
      title1: 'Para los Momentos',
      title2: 'Que se Recuerdan.',
      moments: [
        {
          title: 'Cenas',
          copy: 'El postre que cierra la velada — y abre la conversación.',
        },
        {
          title: 'Cumpleaños',
          copy: 'Un centro de mesa silenciosamente espectacular para el momento más dulce del año.',
        },
        {
          title: 'Aniversarios',
          copy: 'Suave, rico y pausado — un lenguaje de amor servido en rebanadas.',
        },
        {
          title: 'Regalos',
          copy: 'Llega con algo de lo que seguirán hablando mucho después de tu visita.',
        },
        {
          title: 'Mesas Festivas',
          copy: 'Tradición, refinada. Un nuevo ritual digno de conservar.',
        },
        {
          title: 'Eventos Privados',
          copy: 'Un capricho de lote pequeño para momentos que se sienten cuidados.',
        },
      ],
    },
    localLaunch: {
      eyebrow: 'Lanzamiento Local',
      title1: 'Próximamente en',
      title2: 'Magnolia, Texas.',
      copy: 'TARTA se prepara para su primer lanzamiento. Acompáñanos — y reserva tu lugar en la Lista del Primer Bocado para acceso anticipado.',
      points: [
        { label: 'Origen', value: 'Magnolia, Texas' },
        { label: 'Producción', value: 'Lote pequeño' },
        { label: 'Lanzamiento', value: 'Primera edición limitada' },
        { label: 'Disponibilidad', value: 'Pre-órdenes pronto' },
      ],
    },
    instagram: {
      eyebrow: '@tartahtx',
      title1: 'Sigue el',
      title2: 'Primer Capítulo.',
      cta: 'Síguenos @tartahtx',
      posts: ['El primer horneado', 'La caja de autor', 'Un pedacito de cielo'],
    },
    faq: {
      eyebrow: 'Consultas',
      title1: 'Preguntas,',
      title2: 'Respondidas.',
      items: [
        {
          q: '¿Cuándo se lanza TARTA?',
          a: 'Pronto. Únete a la Lista del Primer Bocado para enterarte antes del lanzamiento público.',
        },
        {
          q: '¿Dónde se encuentra TARTA?',
          a: 'TARTA tiene su origen en Magnolia, Texas.',
        },
        {
          q: '¿Habrá pre-órdenes?',
          a: 'Sí. Los detalles de pre-orden se comparten primero con la lista de espera.',
        },
        {
          q: '¿Aceptan pedidos personalizados?',
          a: 'Pedidos personalizados y para eventos podrán estar disponibles tras el lanzamiento.',
        },
        {
          q: '¿Cómo me mantengo al día?',
          a: 'Únete a la lista de espera y síguenos en @tartahtx en Instagram.',
        },
      ],
    },
    finalCTA: {
      edition: 'edición nº 01',
      title1: 'Algo',
      title2: 'Especial',
      title3: 'se Hornea',
      copy1: 'El primer lanzamiento será intencionalmente pequeño.',
      copy2: 'Reserva tu lugar antes de que se abran las puertas.',
      cta: 'Reserva tu primera rebanada',
    },
    footer: {
      tagline: 'Un pedacito de cielo',
      quote: 'Un bocado más cerca del cielo.',
      origin: 'Origen',
      originValue: 'Magnolia, Texas',
      originSub: 'Próximamente',
      follow: 'Síguenos',
      copyright: 'TARTA',
      crafted: 'Hecho con cuidado en Magnolia, Texas',
    },
  },
} as const
